import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="recording-header"
export default class extends Controller {
  static targets = ["recordingStatus"]

  setRecordingState(isRecording) {
    if (isRecording) {
      this.element.style.backgroundColor = "#FFB3C1"  // 赤ピンク
      this.recordingStatusTarget.classList.remove('hidden')
    } else {
      this.element.style.backgroundColor = "#FFFFFF"  // 白（元の色）
      this.recordingStatusTarget.classList.add('hidden')
    }
  }
}